export const MODAL_SHOW = 'MODAL_SHOW'
export const MODAL_HIDE = 'MODAL_HIDE'
export const MODAL_NEXT = 'MODAL_HIDE'

export const FETCH_PRODUCTS_START = 'FETCH_PRODUCTS_START'
export const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS'
export const FETCH_PRODUCT_SUCCESS = 'FETCH_PRODUCT_SUCCESS'
export const FETCH_PRODUCTS_FAIL = 'FETCH_PRODUCTS_FAIL'

export const AUTH_START = 'AUTH_START'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'

export const AUTH_FAIL = 'AUTH_FAIL'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH'
export const SET_AUTH_FACEBOOKURL = 'SET_AUTH_FACEBOOKURL'
export const SET_AUTH_GOOGLEURL = 'SET_AUTH_GOOGLEURL'

export const ADD_PRODUCT = 'ADD_PRODUCT'
export const ADD_TO_CART = 'ADD_TO_CART'
export const SET_CURRENTPRODUCTSTATE = 'SET_CURRENTPRODUCTSTATE'
export const REMOVE_PRODUCT= 'REMOVE_PRODUCT'
export const SET_PRODUCT = 'SET_PRODUCT'
export const FETCH_CART_SUCCESS = 'FETCH_CART_SUCCESS'
export const FETCH_PRODUCT_FAIL = 'FETCH_PRODUCT_FAIL'
